export default "__VITE_ASSET__MlfAeiKi__"